// returns an Icomoon component that it's default iconSet is AgapeIconSet
import IcomoonReact from 'icomoon-react';
import * as React from 'react';
import { useAgapeIcons } from '../../../services/AgapeIconContext';

const AgapeIcon = (props) => {
  const iconSet = useAgapeIcons();
  return <IcomoonReact iconSet={iconSet} {...props} />;
};

export default AgapeIcon;
